import {
  NumberInput as MantineNumberInput,
  NumberInputProps,
} from '@mantine/core';

export type INumberInputProps = NumberInputProps;

/** @registry Design-layer pass-through over Mantine NumberInput; import this instead of @mantine/core NumberInput outside src/design. Extend here when NumberInput needs house behavior. */
export const NumberInput = MantineNumberInput;
